document.addEventListener('DOMContentLoaded', function() {
    function loadMore(listItems, loadMoreBtn, maxItems, loadItems, hiddenClass) {
        [ ...listItems ].forEach(function(item, index) {
            if(index > maxItems - 1) {
                item.classList.add(hiddenClass);
            }
        });

        if(!loadMoreBtn) return;
        loadMoreBtn.addEventListener('click', function(e) {
            e.preventDefault();
            [].forEach.call(document.querySelectorAll(`.${hiddenClass}`), function(
                item,
                index
            ) {
                if(index < loadItems) {
                    item.classList.remove(hiddenClass);
                }

                if(!document.querySelectorAll(`.${hiddenClass}`).length) {
                    loadMoreBtn.style.display = 'none';
                }
            });
        });

        if(!document.querySelectorAll(`.${hiddenClass}`).length) {
            loadMoreBtn.style.display = 'none';
        }
    }

    //gallery load-more
    loadMore(document.querySelectorAll('.js-gallery-item'),
        document.querySelector('.js-gallery-more'),
        12,
        12,
        'hiddenStyle');

});